import { debounce as lodashDebounce } from 'lodash';
import { call } from 'redux-saga/effects';

export const debounce = (saga, ms) => {
  const debounced = lodashDebounce(function* (action) {
    yield call(saga, action);
  }, ms);
  return function* (action) {
    yield debounced(action);
  };
};

